<template>
  <div class="home">
    <div class="login">
      <a
        href="https://account.kkbox.com/oauth2/authorize?redirect_uri=https%3a%2f%2fguoyanting0919.github.io%2fkkboxweb
&client_id=fb254aff20b31017a2e84e34ed896523&response_type=code&state=123"
        class="wasNotLoginContainer"
        v-if="!getCode"
      >
        <i class="fas fa-user wasNotLogin"></i>
        <a class="spanRed">未登入</a>
        <p class="to_open">
          登入開啟
          <br />更多功能
        </p>
      </a>

      <a class="wasLoginContainer" v-else>
        <i class="fas fa-user wasLogin"></i>
        <a class="spanGreen">已登入</a>
        <p class="get_favorite" @click="getMyFavoriteTrack">
          取得我的
          <br />蒐藏歌曲
        </p>
      </a>
    </div>
    <!-- bgRotate -->
    <div>
      <div v-if="searchItems" class="bgRotate"></div>
    </div>
    <!-- iframe -->
    <myIframe></myIframe>

    <!-- navBar -->
    <navBar></navBar>

    <!-- isLoading -->
    <isLoading v-if="isLoading"></isLoading>

    <router-view></router-view>
  </div>
</template>

<script>
import navBar from "./components/navBar";
import myIframe from "./components/iframe";
import isLoading from "./components/isLoading";
export default {
  name: "index",
  components: {
    navBar,
    myIframe,
    isLoading
  },
  data() {
    return {
      token: "",
      kkboxData: "",
      searchInput: "",
      searchType: "",
      kkboxCharts: [],
      artistID: "",
      searchItems: "",
      iframeId: "",
      iframeType: "song",
      YTSearchName: "",
      YTTrackId: "",
      userId: ""
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    getCode() {
      const vm = this;
      let params = new URL(document.location).searchParams;
      if (params) {
        let code = params.get("code");
        vm.$store.commit("CODE", code);
        return code;
      } else {
        return false;
      }
    },
    accessToken() {
      return this.$store.state.accessToken;
    }
  },
  methods: {
    getAccessToken() {
      this.$store.dispatch("getAccessToken");
    },
    getMyFavoriteTrack() {
      const vm = this;
      let path = vm.$router.history.current.path;
      if (path === "/track") {
        vm.$store.dispatch("updateLoading", true);
        const api = "https://api.kkbox.com/v1.1/me/favorite?limit=100";
        const user = {
          headers: {
            Authorization: ` Bearer ${vm.accessToken}`
          }
        };
        vm.$http.get(api, user).then(res => {
          vm.$store.commit("SEARCHITEMS", res.data.data);
          vm.$store.dispatch("updateLoading", false);
        });
      } else {
        // vm.activeRoute = "單曲搜尋";
        vm.$store.commit("ACTIVEROUTER", "單曲搜尋");
        vm.$router.push("/track");
        const api = "https://api.kkbox.com/v1.1/me/favorite?limit=100";
        const user = {
          headers: {
            Authorization: ` Bearer ${vm.accessToken}`
          }
        };
        vm.$http.get(api, user).then(res => {
          vm.$store.commit("SEARCHITEMS", res.data.data);
          vm.$store.dispatch("updateLoading", false);
        });
      }
    },
    getsearchType(i) {
      this.searchType = i;
    },
    getkkboxData(i) {
      this.kkboxData = i;
    },
    getIframeId(i) {
      this.iframeId = i;
    },
    getYTTrackId(i) {
      this.YTTrackId = i;
    },
    getCharts() {
      let vm = this;
      const config = {
        headers: {
          Authorization: ` Bearer ${vm.token}`
        }
      };
      this.$http
        .get(`https://api.kkbox.com/v1.1/charts?territory=TW`, config)
        .then(res => {
          console.log(res);
          vm.kkboxCharts = res.data.data;
        });
    }
  },
  created() {
    const vm = this;
    setTimeout(function() {
      vm.getAccessToken();
    }, 100);
  }
};
</script>

<style lang="scss" scope>
// @import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:300,500,700&display=swap&subset=chinese-traditional");

// @import url("https://fonts.googleapis.com/css?family=Bad+Script&display=swap");
// @import url("https://fonts.googleapis.com/css?family=Quicksand:500&display=swap");
@import url("./assets/app.css");
@import url("./assets/app_RWD.css");

* {
  padding: 0;
  margin: 0;
  font-family: "Noto Sans TC", sans-serif;
}

.home {
  position: relative;
  height: 100%;
  overflow: hidden;
  background-color: black;
}

.bgRotate {
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: black;
}
</style>


